import { render, staticRenderFns } from "./permits_main.vue?vue&type=template&id=4827d738&scoped=true"
import script from "./permits_main.vue?vue&type=script&lang=js"
export * from "./permits_main.vue?vue&type=script&lang=js"
import style0 from "./permits_main.vue?vue&type=style&index=0&id=4827d738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827d738",
  null
  
)

export default component.exports